/**
 *
 * RightActions
 *
 */

import React, { memo, FunctionComponent } from 'react';
import { useIntl } from 'react-intl';
import messages from './messages';
import { accentColorPrim, white } from '../../../../assets/styledAssets/vars';
import { Tooltip } from '@material-ui/core';
import Button from '../../../../components/Button/Button.component';
import {
  AddQuestionIcon,
  GridLayoutIcon,
} from '../../../../components/Icons/Icons.component';
import { Wrap } from '../../../../assets/styledAssets/grid';
import { addQuestion } from '../../Questionnaires.slice';
import { addSection } from '../../Questionnaires.actions';

interface IProps {
  addSection: typeof addSection;
  addQuestion: typeof addQuestion;
  sectionIdx: number;
  questionIdx: number;
}

const RightActions: FunctionComponent<IProps> = ({
  addSection,
  addQuestion,
  sectionIdx,
  questionIdx,
}) => {
  const intl = useIntl();
  return (
    <Wrap
      bs={'0 .6rem 2rem rgba(5, 20, 51, 0.1);'}
      margin={'0 0 0 1.6rem'}
      br={'1rem'}
      bgColor={white}
      flexDir={'column'}
      flexWrap={'nowrap'}
      className={'actions'}
    >
      <Tooltip title={intl.formatMessage(messages.addQuestion)} placement="top">
        <div>
          <Button
            icon
            transparent
            onClick={() => addQuestion({ questionIdx, seriesIdx: sectionIdx })}
          >
            <AddQuestionIcon color={accentColorPrim} width={'1.8rem'} />
          </Button>
        </div>
      </Tooltip>

      {/*          <Tooltip
              title={intl.formatMessage(messages.addQuestion)}
              placement="top"
          >
              <div>
                  <Button icon transparent>
                      <TSquareIcon color={accentColorPrim} width={'1.8rem'} />
                  </Button>
              </div>
          </Tooltip>*/}

      <Tooltip title={intl.formatMessage(messages.addSection)} placement="top">
        <div>
          <Button
            icon
            transparent
            onClick={() => addSection({ seriesIdx: sectionIdx })}
          >
            <GridLayoutIcon color={accentColorPrim} width={'1.8rem'} />
          </Button>
        </div>
      </Tooltip>
    </Wrap>
  );
};

export default memo(RightActions);
